module.exports = __webpack_public_path__ + "img/collection-weddingRingsModern.a2bbf47.jpg";